import React, { Component } from "react";
import Login from "./pages/Login";
import Home from "./pages/Home";
import apiHelper from "../helpers/api";
import "../static/css/general.css";

var token = localStorage.getItem("token");

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertType: "info",
      alertMessage: null,
      isRender: false
    };
  }

  unAuthUser = () => {
    window.history.pushState(null, "", "/");
    localStorage.setItem("token", null);
    token = null;
    this.setState({
      isRender: !this.state.isRender
    });
  };

  logoutUser = () => {
    apiHelper
      .logoutUser(token)
      .then(response => {
        // console.log(response);
        this.unAuthUser();
      })
      .catch(error => {
        // console.log(error);
        this.showAlert("danger", error.message);
      });
  };

  setAuthorizedStatus = token1 => {
    localStorage.setItem("token", token1);
    const tokenSet = localStorage.getItem("token");
    token = tokenSet;
    this.setState({
      isRender: !this.state.isRender
    });
  };

  setAlertNull = () => {
    if (this.state.alertMessage !== null)
      this.setState({
        alertType: "info",
        alertMessage: null
      });
  };

  showAlert = (type, message, timeout = 5000) => {
    if (this.state.alertMessage !== message) {
      if (timeout === -1) {
        this.setState({
          alertType: type,
          alertMessage: message
        });
      } else {
        this.setState(
          {
            alertType: type,
            alertMessage: message
          },
          () => {
            setTimeout(this.setAlertNull, timeout);
          }
        );
      }
    }
  };

  render() {
    let alertBox = null;

    if (this.state.alertMessage) {
      alertBox = (
        <div className={"alert semi-bold alert-" + this.state.alertType}>
          <span className="icon-wrpr">
            <i className="icon icon-ic-warning" />
          </span>
          <span className="msg-wrpr">{this.state.alertMessage}</span>
          <button type="button" className="close" onClick={this.setAlertNull}>
            <i className="icon icon-ic-close" />
          </button>
        </div>
      );
    }

    return (
      <div className="app-wrpr">
        {/* {console.log(token)} */}
        {token && token !== "null" ? (
          <Home
            token={token}
            setAlertNull={this.setAlertNull}
            alertBox={alertBox}
            setAuthorizedStatus={this.setAuthorizedStatus}
            showAlert={(type, message, timeout) =>
              this.showAlert(type, message, timeout)
            }
            logoutUser={this.logoutUser}
            unAuthUser={this.unAuthUser}
          />
        ) : (
          <Login
            alertBox={alertBox}
            setAuthorizedStatus={this.setAuthorizedStatus}
            showAlert={(type, message, timeout) =>
              this.showAlert(type, message, timeout)
            }
          />
        )}
      </div>
    );
  }
}
export default App;
